"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSort = defaultSort;
/* Sorts the given data by the specified column
 * @parameter {array<object>} data - The data to sort
 * @parameter {string} column - the name of the column to sort
 * @parameter {boolean optional} sortAscending - whether or not to sort this column in ascending order
 *
 * TODO: Needs tests!
 */
function defaultSort(data, column) {
  var sortAscending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return data.sort(function (original, newRecord) {
    original = !!original.get(column) && original.get(column) || "";
    newRecord = !!newRecord.get(column) && newRecord.get(column) || "";

    //TODO: This is about the most cheezy sorting check ever.
    //Make it better
    if (original === newRecord) {
      return 0;
    } else if (original > newRecord) {
      return sortAscending ? 1 : -1;
    } else {
      return sortAscending ? -1 : 1;
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ../~/griddle-react/dist/module/utils/sortUtils.js
// module id = 790
// module chunks = 0